export const environment = {
  production: true,
  apiBase: 'https://api-travista.tvshelper.com',
  canScrap: false
};
